import React from "react";
import BaseComponent from "../BaseComponent.js";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";

import Type from "../Global/Typography.js";

const StyledViewMore = styled.div`
  .wrapperViewMore {
    position: absolute;
    right: 10px;
    top: 0px;
    z-index: 3;
    cursor: pointer;
    h6 {
      display: inline-block;
      color: ${nota.color.main.default};
    }
    &:before {
      content: "";
      display: inline-block;
      width: 0;
      height: 0;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      border-top: 15px solid ${nota.color.main.default};
    }
    &:hover {
      h6 {
        font-style: italic;
      }
    }
  }
`;

class ViewMore extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledViewMore onClick={this.props.onClick}>
        <div className="wrapperViewMore">
          <Type.h6>
            <b>{this.translation.geral.viewMore}</b>
          </Type.h6>
        </div>
      </StyledViewMore>
    );
  }
}

export default ViewMore;

// --- // Documentation // --- //
/*
import CardBlock from './../Nano/ViewMore.js';

<ViewMore />
*/
